import { ZodArray, ZodString, z } from 'zod'
import { type any as AnyType } from 'zod/lib/types'

const FormResolverUtils = ({
  schema,
  i18nName,
}: {
  // @ts-ignore
  schema: AnyType
  i18nName: string
}) => {
  const katakana = () => {
    if (!('ZodString' == schema._def.typeName)) {
      throw new Error('Schema type must be string')
    }

    // @ts-ignore
    const katakanaSchema = schema.regex(/^[ァ-ヶー]*$/, `${i18nName}はカタカナのみを入力してください。`)
    return FormResolverUtils({ schema: katakanaSchema, i18nName })
  }

  const numericString = () => {
    if (!('ZodString' == schema._def.typeName)) {
      throw new Error('Schema type must be string')
    }

    const newJoiSchema = schema.regex(/^\d+$/, {
      message: `${i18nName}は数字のみを入力してください。`,
    })

    return FormResolverUtils({ schema: newJoiSchema, i18nName })
  }

  const required = () => {
    if (schema._def.typeName == 'ZodString' || schema._def.typeName == 'ZodArray') {
      const newJoiSchema = schema.min(1, {
        message: `${i18nName}を入力してください。`,
      })

      return FormResolverUtils({ schema: newJoiSchema, i18nName })
    }

    if (schema._def.typeName == 'ZodUnion') {
      const options = schema._def.options.map((option: ZodString | ZodArray<any>) => {
        return option.min(1, {
          message: `${i18nName}を入力してください。`,
        })
      })

      schema._def.options = options
      return FormResolverUtils({ schema, i18nName })
    }

    throw new Error('Schema type must be string or array or union')
  }

  const min = (limit: number) => {
    if (!('ZodString' == schema._def.typeName || 'ZodNumber' == schema._def.typeName)) {
      throw new Error('Schema type must be string or number')
    }

    const newJoiSchema = schema.min(limit, {
      message: `${i18nName}は${limit}文字以上にしてください。`,
    })

    return FormResolverUtils({ schema: newJoiSchema, i18nName })
  }

  const length = (limit: number) => {
    if (!('ZodString' == schema._def.typeName)) {
      throw new Error('Schema type must be string')
    }

    const newJoiSchema = schema
      .min(limit, {
        message: `${i18nName}は${limit}桁にしてください。`,
      })
      .max(limit, {
        message: `${i18nName}は${limit}桁にしてください。`,
      })

    return FormResolverUtils({ schema: newJoiSchema, i18nName })
  }

  const max = (limit: number) => {
    if (!('ZodString' == schema._def.typeName || 'ZodNumber' == schema._def.typeName)) {
      throw new Error('Schema type must be string or number')
    }

    const newJoiSchema = schema.max(limit, {
      message: `${i18nName}は${limit}文字以下にしてください。`,
    })

    return FormResolverUtils({ schema: newJoiSchema, i18nName })
  }

  // enumしたいが予約なので変数名を変更
  const include = (args: Record<string, string | number>) => {
    const values = [...Object.keys(args)]
    // @ts-ignore
    const enumSchema = z.enum(values).refine((value) => values.includes(value), {
      message: `${i18nName}は${Object.values(args)
        .map((value) => `「${value}」`)
        .join('または')}を入力してください`,
    })

    return FormResolverUtils({ schema: schema.and(enumSchema), i18nName })
  }

  return {
    schema,
    katakana,
    required,
    numericString,
    enum: include,
    min,
    max,
    length,
  }
}

export default FormResolverUtils
